<template>
<div class="chapter">
<div class="inner_page">
<p class="C129"><strong><a id="page_v">Contents</a></strong></p><a id="page_v">
</a><p class="C132"><a id="page_v"></a><a href="#/xhtml/05_Acknowledgments#page_vii">Acknowledgments</a></p>
<p class="C131"><a href="#/xhtml/06_Introduction__The_Writer_s_Diet#page_1">Introduction: The Writer’s Diet</a></p>
<p class="C132"><a href="#/xhtml/07_1__Verbal_verve#page_5">1. Verbal verve</a></p>
<p class="C132"><span href="#/xhtml/08_2__Noun_density#page_17" title="Link target outside of Sample">2. Noun density</span></p>
<p class="C132"><span href="#/xhtml/09_3__Prepositional_podge#page_29" title="Link target outside of Sample">3. Prepositional podge</span></p>
<p class="C132"><span href="#/xhtml/10_4__Ad_dictions#page_39" title="Link target outside of Sample">4. Ad-dictions</span></p>
<p class="C131"><span href="#/xhtml/11_5__Waste_words#page_49" title="Link target outside of Sample">5. Waste words</span></p>
<p class="C132"><span href="#/xhtml/12_Afterword__Healthy_writing#page_63" title="Link target outside of Sample">Afterword: Healthy writing</span></p>
<p class="C132"><span href="#/xhtml/13_Appendix__The_WritersDiet_Test#page_67" title="Link target outside of Sample">Appendix: The WritersDiet Test</span></p>
<p class="C132"><span href="#/xhtml/14_References#page_74" title="Link target outside of Sample">References</span></p>
<p class="C132"><span href="#/xhtml/15_Index#page_77" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?95c154b2